import bannerImage from 'assets/events/banner-1.png';
import cn from 'classnames';
import { Button, Heading, P, Section, Wrapper } from 'components/base';
import concat from 'lodash-es/concat';
import includes from 'lodash-es/includes';
import without from 'lodash-es/without';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Check from 'svgs/events/sme/check.svg';
import E01 from 'svgs/events/sme/e01.svg';
import E02 from 'svgs/events/sme/e02.svg';
import E03 from 'svgs/events/sme/e03.svg';
import E04 from 'svgs/events/sme/e04.svg';
import E05 from 'svgs/events/sme/e05.svg';
import { bannerImageC, checkIcon, checkWrapper, checkbox, checkboxLi, checkboxList, e01, e02, e03, e04, e05, headingC, root, showIcon, subheadingC, wording, wrapperB, wrapperC } from './Banner.module.scss';

class Banner extends Component {
  constructor() {
    super();

    this.state = {
      selected: [1, 3, 4],
      result: 0,
    };
  }

  updateSelected = (i) => {
    const selected = this.state.selected;
    if (!includes(selected, i)) {
      return this.setState({ selected: concat(selected, i) },  () => this.calculateResult());
    } else {
      return this.setState({ selected: without(selected, i) },  () => this.calculateResult());
    }
  }

  calculateResult = () => {
    const length = this.state.selected.length;
    if (length <= 1) {
      this.setState({ result: 0 });
    } else if (length >= 2 && length <= 3) {
      this.setState({ result: 60 });
    } else if (length >= 4 && length <= 5) {
      this.setState({ result: 90 });
    } else if (length >= 6) {
      this.setState({ result: 100 });
    } else {
      this.setState({ result: 0 });
    }
  }

  render() {
    const { heading, subheading } = this.props.banner;
    const check = this.props.check;
    const { result } = this.state;
    return (
      <Section className={root} padding="BottomM">
        <Wrapper size="M" className={wrapperB}>
          <h1 className={headingC}>{heading}</h1>
          <h2 className={subheadingC}>{subheading}</h2>
        </Wrapper>
        <Wrapper size="M" className="align-item-center mb-l">
          <a href="#pricing" className={bannerImageC}><img src={bannerImage} /></a>
        </Wrapper>
        <Wrapper size="MS" className={wrapperC}>
          <div className={checkWrapper}>
            <Heading size="M" bold Tag="h3" center marginBottom="Xs">
              {check.heading}
            </Heading>
            <P center marginBottom="S">請勾選 ✔️</P>
            <ul className={checkboxList}>
              { check.list.map((item, i) => (
                <li key={i} className={checkboxLi} onClick={() => this.updateSelected(i)}>
                  <div className={checkbox}>
                    <Check className={cn(checkIcon,{ [showIcon]: includes(this.state.selected, i) })} />
                  </div>
                  <h3>{item}</h3>
                </li>
              )) }
            </ul>
            { result > 0 &&
              <div className="align-item-center mt-s">
                <span className={wording}>你 {result}% 適合我們的服務&nbsp;&nbsp;</span>
                <Button
                  type="tertiary" size="S" text="快來免費試用吧"
                  href="https://app.newsleopard.com/auth/signup?utm_source=SMEcampaignpage&utm_medium=middleCTA&utm_campaign=2021newuser"
                  className="smeCTA"
                />
              </div>
            }
          </div>
        </Wrapper>
        <E01 className={e01} /><E02 className={e02} /><E03 className={e03} /><E04 className={e04} /><E05 className={e05} />
      </Section>
    );
  }
}
Banner.propTypes = {
  banner: PropTypes.object,
  check: PropTypes.object,
};

export default Banner;